import { render } from "./MassHostNotificationsEnable.vue?vue&type=template&id=1f1d2d6c"
import script from "./MassHostNotificationsEnable.vue?vue&type=script&lang=js"
export * from "./MassHostNotificationsEnable.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__